import { Card as AntdCard } from 'antd';
import { createVoidSchemaComponent } from '../../shared';
import { connect, mapProps } from '@formily/react';
const MapedCard = connect(AntdCard, mapProps({
    title: true,
}));
const FormilyCard = createVoidSchemaComponent({
    componentName: 'Card',
    component: MapedCard,
});
export default FormilyCard;
